import Button from './button';

export default Button;



// WEBPACK FOOTER //
// ./src/components/elements/button/index.js